export default __webpack_public_path__ + "static/media/famous.ccf568ca.svg";